import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Lightbox from 'react-images'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import Parser from 'html-react-parser';


class BlogImageGallery extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            shareOpen: false,
            anchorEl: null,
            lightbox: false,
            currentImage: 0,
            photos: props.input.items.map(photo =>
                Object.assign({ 
                    srcSet: photo.gallery_image.localFile.childImageSharp.fluid.srcSet,
                    caption: photo.image_captions.text
                })
            ),
        }
    }

    gotoPrevLightboxImage() {
        const { photo } = this.state
        this.setState({ photo: photo - 1 })
    }

    gotoNextLightboxImage() {
        const { photo } = this.state
        this.setState({ photo: photo + 1 })
    }

    openLightbox(photo, event) {
        event.preventDefault()
        this.setState({ lightbox: true, photo })
    }

    closeLightbox() {
        this.setState({ lightbox: false, currentImage: 0 })
    }


    render() {
        const { input } = this.props
        const photos = input.items
        return (
        <>
            {Parser(input.primary.name_of_the_gallery.html)}
            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 2, 750: 4, 900: 7 }}>
                <Masonry gutter="1rem">
                {photos.map((photo, i) => (
                    <a
                    key={i}
                    href={photo.gallery_image.localFile.childImageSharp.fluid.srcSet}
                    onClick={e => this.openLightbox(i, e)}
                    >
                    <Img fluid={photo.gallery_image.localFile.childImageSharp.fluid} />
                    </a>
                ))}
                </Masonry>
            </ResponsiveMasonry>
            <Lightbox
                backdropClosesModal
                enableKeyboardInput
                showImageCount
                imageCountSeparator={'/'}
                images={this.state.photos}
                preloadNextImage
                currentImage={this.state.photo}
                isOpen={this.state.lightbox}
                onClickPrev={() => this.gotoPrevLightboxImage()}
                onClickNext={() => this.gotoNextLightboxImage()}
                onClose={() => this.closeLightbox()}
            />
        </>
        )
    }
}

BlogImageGallery.propTypes = {
    input: PropTypes.object.isRequired,
};

export default BlogImageGallery;